let promoBenefits, hiringBenefits;

const initBenefitsSlider = function () {
    if (!document.querySelector('.promo-benefits-wrapper')) return;

    document.querySelector('.promo-benefits-wrapper').classList.add('swiper');
    document.querySelector('.promo-benefits-slides-wrapper').classList.add('swiper-wrapper');
    let slides = document.querySelectorAll('.promo-benefits-slide');
    Array.from(slides).forEach((slide, index) => {
        slide.classList.add('swiper-slide');
    });

    const benefitsOptions = {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
        },
    }
    promoBenefits = new Swiper('.promo-benefits-wrapper', benefitsOptions)
}

const initLevelSelector = function () {
    if (!document.querySelector('.promo-level-tab-nav')) return;

    const tabButtons = document.querySelectorAll('.promo-level-tab-nav button'),
        tabs = document.querySelectorAll('.promo-level-tab');

    Array.from(tabButtons).forEach((btn) => {

        btn.addEventListener('click', (e) => {
            let tabId = btn.dataset.tab;
            Array.from(tabButtons).forEach(function (el) {
                el.classList.remove('active');
            });

            btn.classList.add('active');
            Array.from(tabs).forEach(function (el) {
                el.classList.remove('active');
            });

            let tabToActivate = document.querySelector('.' + tabId);
            tabToActivate.classList.add('active');
        });
    });
}

const initHiringProcessSlider = function () {
    const beneFitsElements = document.querySelector('.hiring-texts'),
        stepsWrapper = beneFitsElements.querySelector('.hiring-step-wrapper'),
        hiringSteps = beneFitsElements.querySelectorAll('.hiring-step');

    if (!beneFitsElements) return;

    beneFitsElements.classList.add('swiper');
    stepsWrapper.classList.add('swiper-wrapper');
    Array.from(hiringSteps).forEach((step) => {
        step.classList.add('swiper-slide');
    });

    const benefitsOptions = {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
        },
    }
    hiringBenefits = new Swiper('.hiring-texts', benefitsOptions)
}


document.addEventListener('DOMContentLoaded', () => {
    initLevelSelector();

    if (document.documentElement.clientWidth < 767) {
        initBenefitsSlider();
        initHiringProcessSlider();
    }
});

const crossIcon = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.71635 0.292487C1.32691 -0.0974957 0.695505 -0.0974957 0.306067 0.292487C-0.0833705 0.68247 -0.0833705 1.31476 0.306067 1.70474L3.58973 4.993L0.292078 8.29526C-0.0973591 8.68524 -0.0973595 9.31753 0.292078 9.70751C0.681516 10.0975 1.31292 10.0975 1.70236 9.70751L5.00001 6.40525L8.29764 9.7075C8.68708 10.0975 9.31848 10.0975 9.70792 9.7075C10.0974 9.31752 10.0974 8.68523 9.70792 8.29525L6.41028 4.993L9.69393 1.70475C10.0834 1.31477 10.0834 0.682481 9.69393 0.292499C9.3045 -0.097484 8.67309 -0.097484 8.28366 0.292499L5.00001 3.58074L1.71635 0.292487Z" fill="#7A869A"/> </svg>';

// Simple "fade in" effect realization
if (!Element.prototype.fadeIn) {
    Element.prototype.fadeIn = function () {
        let ms = !isNaN(arguments[0]) ? arguments[0] : 400,
            func = typeof arguments[0] === 'function' ? arguments[0] : (
                typeof arguments[1] === 'function' ? arguments[1] : null
            ),
            displayType = (this.dataset.display) ? this.dataset.display : 'block';

        this.style.opacity = 0;
        this.style.filter = 'alpha(opacity=0)';
        this.style.display = displayType;
        this.style.visibility = 'visible';

        let $this = this,
            opacity = 0,
            timer = setInterval(function () {
                opacity += 50 / ms;
                if (opacity >= 1) {
                    clearInterval(timer);
                    opacity = 1;

                    if (func) func('done!');
                }
                $this.style.opacity = opacity;
                $this.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
            }, 50);
    }
}

// Simple "fade out" effect realization
if (!Element.prototype.fadeOut) {
    Element.prototype.fadeOut = function () {
        let ms = !isNaN(arguments[0]) ? arguments[0] : 400,
            func = typeof arguments[0] === 'function' ? arguments[0] : (
                typeof arguments[1] === 'function' ? arguments[1] : null
            );

        let $this = this,
            opacity = 1,
            timer = setInterval(function () {
                opacity -= 50 / ms;
                if (opacity <= 0) {
                    clearInterval(timer);
                    opacity = 0;
                    $this.style.display = 'none';
                    $this.style.visibility = 'hidden';

                    if (func) func('done!');
                }
                $this.style.opacity = opacity;
                $this.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
            }, 50);
    }
}
/**
 * Check if element already exist in array
 */
if (!Array.prototype.inArray) {
    Array.prototype.inArray = function (comparer) {
        for (var i = 0; i < this.length; i++) {
            if (comparer(this[i])) return true;
        }
        return false;
    }
}

/**
 * Adds element to array if it is not already in array
 */
if (!Array.prototype.pushIfNotExist) {
    Array.prototype.pushIfNotExist = function (element, comparer) {
        if (!this.inArray(comparer)) {
            this.push(element);
        }
    };
}


const dropZone = () => {
    let dzs = document.querySelectorAll('.dropzone');
    if (!dzs) return false;

    dzs.forEach(dz => {
        let dzFile = dz.querySelector('.wpcf7-file');
        let dzText = dz.querySelector('.dropzone__text');

        dz.addEventListener('dragover', (e) => {
            dz.classList.add('file-dropping');
        });

        dz.addEventListener('dragleave', (e) => {
            dz.classList.remove('file-dropping');
        });

        dzFile.addEventListener('change', (e) => {
            dz.classList.remove('file-dropping');
            dzText.innerHTML = '<strong>' + dzFile.files[0].name + '</strong>';
        });
    });
}

const addInputMask = function () {
    let phoneInputs = document.querySelector('.wpcf7-tel');
    if (!phoneInputs) return;
    Inputmask({'mask': '(999) 999-9999'}).mask(phoneInputs);
}

const styleFormSelects = function () {
    if (!document.querySelector('.styled-select')) return;

    let selectPlaceholder = 'Qualification';
    if (document.querySelector('.styled-select').hasAttribute('placeholder')) {
        selectPlaceholder = document.querySelector('.styled-select').attributes.placeholder.value;
    }

    new TomSelect('.styled-select', {
        create: false,
        closeAfterSelect: false,
        placeholder: selectPlaceholder
    });
}

const styleTeamSelect = () => {
    if (!document.getElementById('teamslist')) return;

    new TomSelect('#teamslist', {
        create: false,
        closeAfterSelect: false,
        onChange: function (value) {
            window.location.href = value;
        }
    });
}

const animateForms = function () {
    let wpcf7Elm = document.querySelectorAll('.wpcf7');

    wpcf7Elm.forEach(cf7Form => {
        cf7Form.addEventListener('wpcf7mailsent', event => {

            let formWrapper = cf7Form.querySelector('.form-wrapper');
            let thankYouMessage = cf7Form.querySelector('.form-thanks');
            formWrapper.fadeOut(600, thankYouMessage.fadeIn(500));
            // send dataLayer event
            if (!event.target.form_id) return;

            window.dataLayer.push({
                'event': 'form_submit',
                'form_id': event.target.form_id.value
            });

        });
    });
}

const setupJobSliders = function () {
    if (!document.body.classList.contains('single-job')) return;
    let benefitsSliderOptions = {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    }

    const benefitsSlider = new Swiper('.block-benefits .swiper', benefitsSliderOptions);

    let thumbsSliderParams = {
        direction: window.innerWidth < 992 ? 'horizontal' : 'vertical',
        spaceBetween: 10,
        slidesPerView: 3,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    }

    const thumbsSlider = new Swiper('.visuals-thumbs', thumbsSliderParams);

    const mainSlider = new Swiper('.visuals-main', {
        effect: 'fade',
        autoplay: {
            delay: 2500
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: thumbsSlider,
        },
    });

    window.addEventListener('resize', () => {
        if (thumbsSlider.params.direction === 'vertical' && window.innerWidth < 992) {
            thumbsSlider.changeDirection('horizontal');
        }
        if (thumbsSlider.params.direction === 'horizontal' && window.innerWidth >= 992) {
            thumbsSlider.changeDirection('vertical');
        }
    });
}

// Tabs on single Career page
const jobsTabs = () => {
    if (!document.querySelector('.job-tabs')) return;

    let tab_nav = document.querySelector('.job-tabs'),
    tab_contents = document.querySelectorAll('.job-tab-content');

    if (tab_nav) {
        let tabs = document.querySelectorAll('.job-tab');
        let clostBtns = document.querySelectorAll('.close-accordion');

        tabs.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();

                tabs.forEach((link) => {
                    link.classList.remove('active');
                })

                elem.classList.add('active');
                tab_contents.forEach((tc) => {
                    tc.classList.remove('active');
                });

               // let target_id = elem.children[0].getAttribute('href');
                // get data-href attribute
                if (elem.children[0].hasAttribute('data-href')) {
                    target_id = elem.children[0].getAttribute('data-href');
                }
                //let target = document.getElementById(target_id.substring(1)).classList.add('active');
                let target = document.querySelector(`[data-id="${target_id.substring(1)}"]`).classList.add('active');                
            })
        });

        const hideTabs = () => {
            let panels = document.querySelectorAll('.job-tab-content');
            for (let panel of panels) {
                panel.classList.remove('active');
            }
        }

        clostBtns.forEach(elem => {
            elem.addEventListener('click', (e) => {
                elem.closest('.job-tab-content').classList.remove('active');
            })
        });

        for (let singleTab of tab_contents) {
            singleTab.querySelector('h3.accordion-heading').addEventListener('click', e => {
                e.preventDefault();
                hideTabs();
                singleTab.classList.add('active');
                // scroll to top of the tab on mobile
                if (window.innerWidth < 884) {
                    window.scrollTo({
                        top: singleTab.offsetTop - 100,
                        behavior: 'smooth'
                    });
                }
            
            });
        }
    }
}

const setupSearchForm = () => {

    const vacancy_filter = document.forms.vacancy_filter;
    if (!vacancy_filter) return;

    let csCategory = document.querySelector('#careers-category').nodeName == 'SELECT' ?
        new TomSelect(document.querySelector('#careers-category'), {
            create: false,
            closeAfterSelect: false
        }) : false;

    let csLocation = document.querySelector('#careers-locations').nodeName == 'SELECT' ?
        new TomSelect(document.querySelector('#careers-locations'), {
            create: false,
            closeAfterSelect: false
        }) : false;

    document.querySelector('.view-all-jobs').addEventListener('click', ()=>{
        vacancy_filter.querySelector('[type="submit"]').click();
    });

    vacancy_filter.addEventListener('submit', (e) => {
        e.preventDefault();

        let catId = document.getElementById('careers-category').value,
            locationId = document.getElementById('careers-locations').value,
            searchString = document.getElementById('search').value,
            container = document.querySelector('.vacancy-results'),
            blockContainer = vacancy_filter.closest('.container'),
            tagLine = document.querySelector('.search-tags'),
            $submit = vacancy_filter.querySelector('[type="submit"]'),
            skills = [];

        blockContainer.classList.add('loading');
        container.innerHTML = '';

        let data = {
            'action': 'load_jobs',
            'cat': catId,
            'location': locationId,
            'search_string': searchString
        }

        postData(surprise_ajax_params.ajaxurl, new URLSearchParams(data))
            .then(data => {
                container.innerHTML = data;
                blockContainer.classList.remove('loading');
            })
            .then(() => {
                updateVacanciesCount();
                vacResults = new Isotope(document.querySelector('.vacancy-results', {layoutMode: 'fitColumns'}), {
                    itemSelector: '.vacancy-card',
                });
            })
            .catch(error => console.error('Err', error));

        let skillsData = {
            'action': 'load_job_skills',
            'cat': catId,
            'location': locationId,
            'search_string': searchString
        }

        postData(surprise_ajax_params.ajaxurl, new URLSearchParams(skillsData))
            .then(data => {
                document.querySelector('.vacancy-skills').innerHTML = data;
            }).then(() => {
            let $skill = document.querySelectorAll('.skill');
            let currentFilter = [];
            $skill.forEach(elem => {
                elem.addEventListener('click', (e) => {
                    let slug = elem.dataset.slug;
                    let text = elem.innerText.trim();
                    if (elem.classList.contains('active')) {
                        currentFilter = currentFilter.filter((value, index, arr) => {
                            return value !== '.' + slug;
                        })
                    } else {
                        let tagHtml = `<span class="search-tag skill-tag" data-slug="${slug}">${text}${crossIcon}</span>`;
                        tagLine.insertAdjacentHTML('beforeend', tagHtml);
                        currentFilter.push('.' + slug);
                    }

                    let filterLine = currentFilter.length > 0 ? currentFilter.join(', ') : '*';
                    vacResults.arrange({filter: filterLine});
                    let vacFilteredCount = vacResults.getFilteredItemElements();
                    updateVacanciesCount(vacFilteredCount.length);

                    let addedTag = document.querySelector(`.skill-tag[data-slug=${slug}]`);
                    addedTag.addEventListener('click', function (e) {
                        let curElement = this;
                        let curSlug = this.dataset.slug;
                        currentFilter = currentFilter.filter((value, index, arr) => {
                            return value !== '.' + curSlug;
                        });

                        let filterLine = currentFilter.length > 0 ? currentFilter.join(', ') : '*';
                        vacResults.arrange({filter: filterLine});
                        updateVacanciesCount(vacResults.getFilteredItemElements().length);

                        document.querySelector(`.skill-tag[data-slug=${curSlug}]`).remove();
                        document.querySelector(`.skill.active[data-slug=${curSlug}]`).classList.remove('active');
                    });

                    elem.classList.toggle('active');
                })
            });
        }).catch(error => console.error('Err', error));

        document.querySelector('.vacancy-tagline').style.display = 'block';

        tagLine.innerHTML = '';

        if (catId && catId !== '-1' && csCategory) {
            tagLine.insertAdjacentHTML("beforeend", '<span class="search-tag category-tag">' + document.querySelector('#careers-category').selectedOptions[0].text + crossIcon + '</span>');
            let catTag = document.querySelector('.category-tag');
            catTag.addEventListener('click', (e) => {
                csCategory.setValue('-1');
                e.target.remove();
                $submit.click();
            });
        }

        if (locationId && locationId !== '-1' && csLocation) {
            tagLine.insertAdjacentHTML("beforeend", '<span class="search-tag location-tag">' + document.querySelector('#careers-locations').selectedOptions[0].text + crossIcon + '</span>');
            let locTag = document.querySelector('.location-tag');
            locTag.addEventListener('click', (e) => {
                csLocation.setValue('-1');
                e.target.remove();
                $submit.click();
            });
        }

    });

}

const teamShowMore = () => {
    let showMoreBtn = document.querySelector('.team-show-more');
    if (!showMoreBtn) return;

    showMoreBtn.addEventListener('click', () => {
        setTimeout(() => {
            document.querySelector('.team-members.hidden').fadeIn();
        }, 500)
        showMoreBtn.fadeOut();

    });
}

const updateVacanciesCount = (count = null) => {
    let postCount = document.querySelector('.post-count');
    let number = (count == null) ? document.querySelectorAll('.vacancy-card').length : count;
    postCount.innerHTML = (number == 0) ? 'no vacancies' :
        number + '&nbsp;' + ((number < 2) ? 'vacancy' : 'vacancies');
}

document.addEventListener('DOMContentLoaded', () => {
    // CF7 Forms
    dropZone();
    addInputMask();
    styleFormSelects();

    // Job page
    setupJobSliders();
    jobsTabs();

    // Job search forms
    setupSearchForm();
    animateForms();

    // Team pages related
    styleTeamSelect();
    teamShowMore();
});
